import { useQuery } from '@tanstack/react-query';
import { useFormikContext } from 'formik';

import { ReadOnlyField } from '../../cdl/ReadOnlyField/ReadOnlyField';
import { queries } from '../../common/api/queryKeys/queries';
import { CustomerGroupSelect } from '../../common/form-elements/CustomerGroupSelect/CustomerGroupSelect';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';
import type { DemandDefinitionState } from '../types/DemandDefinitionState';

interface DemandDefinitionCustomerGroupFieldProps {
    definitionId?: string;
}

export const DemandDefinitionCustomerGroupField = ({ definitionId }: DemandDefinitionCustomerGroupFieldProps) => {
    const { setTouched, setValues, touched, values } = useFormikContext<DemandDefinitionState>();
    const customerGroupQuery = useQuery({
        ...queries.customerGroups.detail(values.customerGroupId ?? ''),
        enabled: definitionId !== undefined && values.customerGroupId !== undefined,
    });

    return (
        <Box marginBottom={24}>
            {definitionId ? (
                <ReadOnlyField
                    label={translate('customerGroupSelect.label')}
                    value={customerGroupQuery.data?.name ?? ''}
                />
            ) : (
                <CustomerGroupSelect
                    label={translate('customerGroupSelect.label')}
                    placeholder={translate('customerGroupSelect.placeholder')}
                    value={values.customerGroupId ?? null}
                    onChange={(customerGroupId) => {
                        setTouched({ ...touched, fleetChanges: [] }, false);
                        setValues({
                            ...values,
                            customerGroupId: customerGroupId ?? undefined,
                            excludedCompanyIds: [],
                            adjustments: [],
                            fleetChanges: [],
                            leavingVessels: [],
                        });
                    }}
                />
            )}
        </Box>
    );
};
